"use strict";

// This is an editorial setting rather than a clock-derived value. Switch it
// only when the site should start presenting another year as the active year.
const CURRENT_SCHEDULE_YEAR = 2026;
const SCHEDULE_YEARS = Object.freeze([2026, 2025, 2024, 2023, 2022]);
const SCHEDULE_ALIAS_PATH = "/schedule";
const SCHEDULE_YEAR_PREFIX_PATTERN = /^(\d{4})-/;

const schedulePathForYear = (year) => {
  if (!Number.isInteger(year) || !SCHEDULE_YEARS.includes(year)) {
    throw new Error(`Unconfigured schedule year: ${year}`);
  }

  return `${SCHEDULE_ALIAS_PATH}/${year}`;
};

if (
  !SCHEDULE_YEARS.length ||
  !SCHEDULE_YEARS.includes(CURRENT_SCHEDULE_YEAR) ||
  new Set(SCHEDULE_YEARS).size !== SCHEDULE_YEARS.length ||
  SCHEDULE_YEARS.some(
    (year, index) =>
      !Number.isInteger(year) ||
      (index > 0 && year >= SCHEDULE_YEARS[index - 1])
  )
) {
  throw new Error(
    "Schedule years must be unique, newest-first, and include the current year."
  );
}

const SCHEDULE_CANONICAL_PATH = schedulePathForYear(CURRENT_SCHEDULE_YEAR);

const scheduleYearForPath = (routePath) => {
  const matchingYear = SCHEDULE_YEARS.find(
    (year) => schedulePathForYear(year) === routePath
  );

  return matchingYear === undefined ? null : matchingYear;
};

const scheduleStructuredDataYearsForItems = (scheduleItems) => {
  if (!Array.isArray(scheduleItems)) {
    throw new TypeError("Schedule items must be an array.");
  }

  const occurrenceYears = new Set();

  scheduleItems.forEach((item, itemIndex) => {
    if (!item || typeof item !== "object" || !Array.isArray(item.occurrences)) {
      throw new TypeError(
        `Invalid schedule item at position ${itemIndex + 1}.`
      );
    }

    item.occurrences.forEach((occurrence, occurrenceIndex) => {
      const match =
        occurrence &&
        typeof occurrence.startDate === "string" &&
        occurrence.startDate.match(SCHEDULE_YEAR_PREFIX_PATTERN);

      if (!match) {
        throw new Error(
          `Invalid schedule occurrence at position ${occurrenceIndex + 1} for ${
            item.id || `item ${itemIndex + 1}`
          }.`
        );
      }

      const year = Number(match[1]);
      if (!SCHEDULE_YEARS.includes(year)) {
        throw new Error(
          `Schedule occurrence year is not configured: ${year}`
        );
      }
      occurrenceYears.add(year);
    });
  });

  return Object.freeze(
    SCHEDULE_YEARS.filter(
      (year) => year >= CURRENT_SCHEDULE_YEAR && occurrenceYears.has(year)
    )
  );
};

module.exports = Object.freeze({
  CURRENT_SCHEDULE_YEAR,
  SCHEDULE_ALIAS_PATH,
  SCHEDULE_CANONICAL_PATH,
  SCHEDULE_YEARS,
  schedulePathForYear,
  scheduleStructuredDataYearsForItems,
  scheduleYearForPath,
});
